import React from 'react'
import useIntersectionObserver from '../../hooks/useIntersectionObserver'

export const RevealOnScroll = ({
    children,
    animation = 'reveal-up',
    delay = 0,
    threshold = 0.1,
    className = ''
}) => {
    const ref = useIntersectionObserver({ threshold, once: true })

    return (
        <div
            ref={ref}
            className={`${animation} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </div>
    )
}

export default RevealOnScroll
